import React from "react";
import css from "./Footer.module.css";

const Footer = () => (
  <div className={css.footer}>
    <a
      className={css.unipd}
      href="https://www.unipd.it/en/"
      title="University of Padova"
    />
    <div className={css.cite}>
      <div className={css.usefulDatabase}>
        If you find this database useful, please cite:
      </div>
      <div className={css.paper}>
        [Placeholder] Corso D, Romualdi C, Sales G.{" "}
        <strong>
          itGraph: InTeractive GRAPHite for pathway visualization [bioRxiv] [
          <a title={"Sales-Lab"} href={"https://sales.bio.unipd.it/"}>
            Sales-Lab
          </a>
          ]
        </strong>
      </div>
    </div>
    <a
      className={css.dibio}
      href="https://www.biologia.unipd.it/en/"
      title="Department of Biology"
    />
  </div>
);

export default Footer;
